<template>
 <!--Ionic Slider-->
 <ion-grid class="spacer">
 
    <ion-row>
        <ion-col sizeXs="12" sizeMd="12" sizeLg="12" sizeXl="7">
        <ion-button class="importButton ion-float-right" color="dark" @click="showModal()">Import Playlist</ion-button>
                <simple-modal :is-open="modalInfo.show" @modal-closed="handleModalClosed"/>

            <ion-text color="primary">
                <h2 class="ion-margin-start" ><b>Popular Playlists</b></h2>

            </ion-text>
               
            <ion-text color="primary">
                <h3 class="ion-margin-start">By The Community</h3>
                
            </ion-text>
        <p id="OK"></p>


        

            <ion-slides scrollbar="true" pager="false" :options="slideOpts">
                <ion-slide  v-for="todo in communityPlaylist" :key="todo.playlistId">
                    <ion-card @click="redirect(todo.playlistId)">
                        
                        <div v-for="n in getPlaylistDetails(todo)" :key="n.spotifyId">
                            <div v-for="(z,index) in n" :key="z.spotifyId">

                                <img v-if="index === 0" :src="z.imgUrl" class="card-img">

                            </div>   
                        </div> 

                        <ion-card-title class="ion-margin-top ion-margin-bottom ion-margin-start">{{todo.playlistName}}</ion-card-title>

                        <ion-card-content>
                            <p style="margin-left: 12px;"> {{todo.userId}} </p>
                        </ion-card-content>
                    </ion-card>
                </ion-slide>
            </ion-slides>


            <ion-text color="primary">
                <h3 class="ion-margin-start">Trending</h3>
            </ion-text>


            <ion-slides scrollbar="true" pager="false" :options="slideOpts">
                <ion-slide  v-for="todo in chartsPlaylist" :key="todo.playlistId">
                    <ion-card @click="redirect(todo.playlistId)">
                        
                        <div v-for="n in getPlaylistDetails(todo)" :key="n.spotifyId">
                            <div v-for="(z,index) in n" :key="z.spotifyId">

                                <img v-if="index === 0" :src="z.imgUrl" class="card-img">

                            </div>   
                        </div> 
                        <ion-card-title class="ion-margin-top ion-margin-bottom ion-margin-start">{{todo.playlistName}}</ion-card-title>

                        <ion-card-content>
                        <p style="margin-left: 12px;"> No of Exports: {{todo.noOfExports}} </p>
                            <p style="margin-left: 12px;"> {{todo.userId}} </p>
                        </ion-card-content>
                    </ion-card>
                </ion-slide>
            </ion-slides>


        </ion-col>

        <ion-col>
            <ion-text color="primary">
                <h3 class="ion-margin-start">Recommended Events</h3>
            </ion-text>
            
            <ion-list v-for="fetch in eventList" :key="fetch.event">
           
              <ion-item v-for="l in fetch" lines="none" :key="l.id" @click="openEvent(l.uri)"  class="eventlist">
                    
                  <ion-label color="light">
                     <!--{{ getImage(l.performance[0].displayName)}}-->
                   
   
                <!---->
                    <div class="eventContainer">
                    <div class ="eventCover" v-bind:style="{ backgroundImage: 'url(https://images.sk-static.com/images/media/profile_images/artists/' + l.performance[0].artist.id + '/huge_avatar), url(https://images.sk-static.com/images/media/profile_images/events/' + l.id + '/huge_avatar)' }">
                   

                    </div> 
                    <div class ="eventDetails">  




                     <p v-if="l.displayName.length < 50" ><b>{{ l.displayName }}</b></p>
                     <p v-else ><b>{{ l.displayName.substring(0,40) }} ...</b></p>
  
                      
                       
                      <h3>
                        <b> {{ l.performance[0].displayName}}</b>
                        
                      </h3>
                      <br>
                      <h3> {{l.location.city}}</h3>
                      </div>
                   </div>

                     
                  </ion-label>



              </ion-item>
            </ion-list>

        </ion-col>
    </ion-row>
 </ion-grid>
</template>

<script lang="ts">
import { alertController } from '@ionic/vue';
import { defineComponent, reactive } from 'vue';
import axios from 'axios';
import { useRouter } from 'vue-router';
import SimpleModal from './SimpleModal.vue';
import VueLodash from 'vue-lodash';

export default defineComponent({
  components:{ SimpleModal },
  data() {
    return {
      communityPlaylist: [],
      chartsPlaylist: [],
      eventList: [],
      imgArr: '',
      
    }
  },
 setup() {
    // const revents = [{
    //     'event_name': 'Lewis Concert'
    // }]

    const modalInfo = reactive <{ show: boolean; data: any}>({
      show: false,
      data:null
    })

    const showModal = () => {
      modalInfo.show = true;
    }

    const handleModalClosed = (eventData: any) =>{
      modalInfo.show = false
      //alert(JSON.stringify(eventData))
    }
    const router = useRouter();
 
    // Optional parameters to pass to the swiper instance. See http://idangero.us/swiper/api/ for valid options.
    const slideOpts = {
      slidesPerView: 3,
      spaceBetween: 10,
      initialSlide: 0,
      speed: 100,
      breakpoints: {
        // when window width is >= 320px
        320: {
        slidesPerView: 2,
        spaceBetween: 0
        },
        // when window width is >= 480px
        768: {
        slidesPerView: 3,
        spaceBetween: 30
        },
        // when window width is >= 640px
        1024: {
        slidesPerView: 5,
        spaceBetween: 0
        }
    }
    };

    return { handleModalClosed, modalInfo, showModal, slideOpts, router }
  },
  methods: {
    redirect(id: string){
      console.log("CLICKED");
        this.router.push('/music/recommended/p/' + id);
    },
    getPlaylistDetails(items: Record<string, any>){
        //const carditems = items.songs
        //console.log("hello")
        //console.log(carditems)
        const carditems = items.songs
        return {carditems}
    },
    getChartsDetails(items: Record<string, any>){
        //const carditems = items.songs
        //console.log("hello")
        //console.log(carditems)
        const carditems = items.songs
        return {carditems}
    },
      openEvent(uri: string){
    window.open(uri,'name','width=500,height=700')
    },
        // getImage(search: string){
        //     // const imgURL = "wneongewn.ewonfewn.cwe" + Math.random()

        //     // this.getImageSearch(search).then(data => {
        //     //     //console.log(data.artists.items[0].images[0]); // JSON data parsed by `data.json()` call
        //     //     this.imgArr += "," + data.artists.items[0].images[0].url
        //     //     return data.artists.items[0].images[0].url

        //     // })
        //     // console.log(this.imgArr)
        //     return ""
        // },


    // async getImageSearch(search: string) {
    //             const url= `https://api.spotify.com/v1/search?q=` + encodeURI(search || '') + `&type=artist`;
    //             const usertoken = localStorage.getItem("accesstoken");
    //             const response = await fetch(url, {
    //                 method: 'GET',
    //                 headers: {
    //                 'Authorization': 'Bearer ' + usertoken,
    //                 // 'Content-Type': 'application/x-www-form-urlencoded',
    //                 },
    //                 redirect: 'follow', // manual, *follow, error
    //                 referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
    //                 // body: JSON.stringify(data) // body data type must match "Content-Type" header
    //             });
    //             return response.json(); // parses JSON response into native JavaScript objects
    //     },




    //   const data = (await res.json());
    //     console.log(data.artists.items[0].images[0].url)

    //     if(data.artists.items[0].images[0].url !== undefined){
    //         console.log(data.artists.items[0].images[0].url)
    //         return JSON.stringify(data.artists.items[0].images[0].url)
    //     }else{
    //         return "https://lastfm.freetls.fastly.net/i/u/300x300/2a96cbd8b46e442fc41c2b86b821562f.png"
    //     }
 
   //},


//    async getImage(search: string) {
//     const usertoken = localStorage.getItem("accesstoken")

//       await fetch( `https://api.spotify.com/v1/search?q=` + encodeURI(search || '') + `&type=artist`, { 'headers': {'Authorization': 'Bearer ' + usertoken }}).then(res=>{
//             const data = res.json()
//             console.log(data)
//             return data
            
//       })




//     //   const data = (await res.json());
//     //     console.log(data.artists.items[0].images[0].url)

//     //     if(data.artists.items[0].images[0].url !== undefined){
//     //         console.log(data.artists.items[0].images[0].url)
//     //         return JSON.stringify(data.artists.items[0].images[0].url)
//     //     }else{
//     //         return "https://lastfm.freetls.fastly.net/i/u/300x300/2a96cbd8b46e442fc41c2b86b821562f.png"
//     //     }
 
//    },
  
  },
  created() {
    const usertoken = localStorage.getItem("accesstoken")
    console.log("OOOOK")

    axios.get('https://us-central1-nightingale-1d29b.cloudfunctions.net/getAllPlaylist')
          .then(
              res => {
                const dataOne = res.data
                const dataTwo = dataOne.slice();
                this.communityPlaylist = dataOne
                this.chartsPlaylist = dataTwo.sort((a: Record<string, any>, b: Record<string, any>) => (b.noOfExports > a.noOfExports) ? 1 : -1)
              });


        window.addEventListener('playlist-deleted', event => {
       axios.get('https://us-central1-nightingale-1d29b.cloudfunctions.net/getAllPlaylist')
      .then( res => {
                
                const dataOne = res.data
                const dataTwo = dataOne.slice();
                this.communityPlaylist = dataOne
                this.chartsPlaylist = dataTwo.sort((a: Record<string, any>, b: Record<string, any>) => (b.noOfExports > a.noOfExports) ? 1 : -1)
                
              });


                             const userpid = localStorage.getItem("userID")
    axios.get('https://us-central1-nightingale-1d29b.cloudfunctions.net/GetMostPopularArtist2?userId=' + userpid) //For events
      .then(
          res => {  
             
         
            
              this.eventList = res.data.resultsPage.results}).then(data=>{

                console.log(this.eventList)
              })

          
              });
                  const userpid = localStorage.getItem("userID")
    axios.get('https://us-central1-nightingale-1d29b.cloudfunctions.net/GetMostPopularArtist2?userId=' + userpid) //For events
      .then(
          res => {  
             
         
            
              this.eventList = res.data.resultsPage.results}).then(data=>{

                console.log(this.eventList)
              })






    window.addEventListener('userID-Added', event => {

    const userpid = localStorage.getItem("userID")
    axios.get('https://us-central1-nightingale-1d29b.cloudfunctions.net/GetMostPopularArtist2?userId=' + userpid) //For events
      .then(
          res => {  
             
           
            console.log(res.data.resultsPage.results)
              this.eventList = res.data.resultsPage.results}).then(data=>{

                console.log(this.eventList)
              })

          
              })
   


    
  }, 


     
});
</script>


<style scoped>
.card-img{
        padding:0;
    }
ion-card-title{
    color:#fefefe;
    text-align:left;
    font-size:15px;
    margin-top: 7px;
    font-weight:bold;
    margin-left: 3px;

}
ion-card-content{
    text-align:left;
    font-size:12.5px;
    margin-top: -25px;
    margin-left: -25px;
}

.spacer{
    margin-left: 5px;
    margin-right: 5px;
}

.card-text-adj{
    margin-left:-20px;
}

.alert-button {
    color: red !important;
}
ion-item{
   --ion-background-color:#171717;
   padding-top: 10px;
   padding-bottom: 10px;

}
.importButton{
    margin-top:20px;
}

.eventCover{
    height:100px;
    width: 100px;
    background-size:     cover;                      /* <------ */
    background-repeat:   no-repeat;
    background-position: center center;
   float: left;
   border-radius: 10px;
}

.eventContainer{
    margin: auto;
}
.eventDetails{
margin-left: 120px;
text-overflow: ellipsis;
}

</style>


